import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PrintNode.frontend.types'

@Injectable({ providedIn: 'root' })
export class PrintNode_print_request_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { printerId: number, content: string, contentType?: string }): Promise<{ outputDetails?: string, printJobId?: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.printerId)) {
      missingRequiredInParams.push('\'printerId\'');
    }
    if (isNil(inParams.content)) {
      missingRequiredInParams.push('\'content\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PrintNode/functions/print_request_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

